export default __webpack_public_path__ + "static/media/eur-flag.1a2784a9.svg";